import ApiBase from './Api'

const DASHBOARD_API_PATHS = {
    DASHBOARD: (nameOfDashboard: string | null) => `/admin/dashboard${nameOfDashboard ? '/' + nameOfDashboard : ''}`,
}

class DashboardApi extends ApiBase {
    async find(nameOfDashboard: string | null = null) {
        const response = await this._getRequest(DASHBOARD_API_PATHS.DASHBOARD(nameOfDashboard))

        return response
    }
}

export default DashboardApi
